export const markerCluster = {
    options: {
        showCoverageOnHover: true,
        zoomToBoundsOnClick: true,
        spiderfyOnMaxZoom: true,
        removeOutsideVisibleBounds: false,
        spiderLegPolylineOptions: {
            weight: 1.5,
            color: '#222',
            opacity: 0.5
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/configs/marker_cluster.js